import React, { useState, useEffect } from "react";
import Icon from "@mdi/react";
import {
  mdiClipboardAccount,
  mdiBookEducation,
  mdiBriefcaseEdit,
} from "@mdi/js";
import "../CSS/Resumen.css";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import Preload from "./Preload";
import { useLoadingContext } from "../context/LoadingContext";

const apiUrl = process.env.REACT_APP_API_URL;
const Path_Trabajo = require.context("../Images/trabajo", true);
const Path_Trabajos = require.context("../Images/trabajos", true);
const Path_Logos_Educacion = require.context("../Images/educacion", true);

function resolvePhoto(context, filename) {
  if (!filename) return null;
  if (/^https?:\/\//i.test(filename)) return filename;
  
  const cleanName = filename.replace(/^\.\//, "");
  
  // Primero intenta con el contexto proporcionado (Educacion o Trabajo secundario)
  try {
    return context(`./${cleanName}`);
  } catch {
    // Si falla, intenta en las carpetas de trabajo generales
    try {
      return Path_Trabajos(`./${cleanName}`);
    } catch {
      try {
        return Path_Trabajo(`./${cleanName}`);
      } catch {
        return filename; 
      }
    }
  }
}

function formatDate(startDate, endDate) {
  const start = moment(startDate, "YYYY-MM-DD")
    .locale("es")
    .format("D [de] MMMM [de] YYYY");
  const end = moment(endDate, "YYYY-MM-DD").locale("es");
  return `${start} - ${end.isValid() ? end.format("D [de] MMMM [de] YYYY") : "Actualidad"}`;
}

function formatDateOne(startDate) {
  return moment(startDate, "YYYY-MM-DD")
    .locale("es")
    .format("D [de] MMMM [de] YYYY");
}

function dateValidate(date) {
  return moment(date, "YYYY-MM-DD").isValid() ? "" : "active";
}

const Resumen = () => {
  const [empleos, setEmpleos] = useState(null);
  const [educacion, setEducacion] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { register, done } = useLoadingContext();

  useEffect(() => {
    register();
    Promise.all([axios.get(apiUrl + "jobs"), axios.get(apiUrl + "studies")])
      .then(([jobsRes, studiesRes]) => {
        const jobsWithSortCriteria = jobsRes.data.map((item) => {
          const hasNoEndDate = !moment(
            item.dateEnd,
            "YYYY-MM-DD",
            true,
          ).isValid();
          const sortDate = new Date(item.dateEnd || 0).getTime();
          return {
            ...item,
            photo: resolvePhoto(Path_Trabajo, item.photo),
            hasNoEndDate,
            sortDate,
          };
        });

        setEmpleos(
          jobsWithSortCriteria
            .sort((a, b) => {
              if (a.hasNoEndDate && !b.hasNoEndDate) return -1;
              if (!a.hasNoEndDate && b.hasNoEndDate) return 1;
              return b.sortDate - a.sortDate;
            })
            .map(({ sortDate, hasNoEndDate, ...item }) => item),
        );
        setEducacion(
          studiesRes.data.map((item) => ({
            ...item,
            photo: resolvePhoto(Path_Logos_Educacion, item.photo),
          })),
        );
        setIsLoading(false);
      })
      .catch(console.error)
      .finally(done);
  }, [done, register]);

  if (isLoading) {
    return <Preload />;
  }

  return (
    <div id="experience" className="content_box">
      <h1 className="content_box_title">
        <Icon path={mdiClipboardAccount} className="Main_Icons" size={1} />
        Resumen
      </h1>
      <div className="content_box_resumen">
        <div className="column">
          <h1 className="content_box_title">
            <Icon path={mdiBriefcaseEdit} className="Main_Icons" size={1} />
            Experiencia
          </h1>
          <ul className="content_box_resumen_list">
            {empleos &&
              empleos.map((item, index) =>
                item.charge !== "camilo" ? (
                  <li
                    className="content_box_resumen_list_item"
                    key={item.id ?? index}
                  >
                    <ul className={dateValidate(item.dateEnd)}>
                      <li>
                        <span>Empresa:</span> {item.enterprise}
                      </li>
                      <li>
                        <span>Duración:</span>{" "}
                        {formatDate(item.dateEntry, item.dateEnd)}
                      </li>
                      <li>
                        <span>Cargo:</span> {item.charge}
                      </li>
                      <li>
                        <span>Trabajo:</span> {item.work}
                      </li>
                    </ul>
                    <div className="content_box_resumen_icon_div">
                      <img
                        className="content_box_resumen_icon"
                        src={item.photo}
                        alt={item.enterprise}
                      />
                    </div>
                  </li>
                ) : null,
              )}
          </ul>
        </div>
        <div className="column">
          <h1 className="content_box_title">
            <Icon path={mdiBookEducation} className="Main_Icons" size={1} />
            Estudios
          </h1>
          <ul className="content_box_resumen_list">
            {educacion &&
              educacion.map((item, index) => (
                <li
                  className="content_box_resumen_list_item"
                  key={item.id ?? index}
                >
                  <ul className={dateValidate(item.dateEnd)}>
                    <li>{formatDateOne(item.dateEnd)}</li>
                    <li>
                      <span>{item.institution}</span>
                    </li>
                    <li>{item.title}</li>
                    <li>{item.direction}</li>
                  </ul>
                  <div className="content_box_resumen_icon_div">
                    <img
                      className="content_box_resumen_icon"
                      src={item.photo}
                      alt={item.institution}
                    />
                  </div>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Resumen;
